module.exports = __webpack_public_path__ + "static/media/ic_check-green.46bd2a18.svg";